export const approvePayout = {
  approvePayout: "Approve Payout V1",
  from: "From",
  to: "To",
  notification: "Notification",
  customerPhone: "Customer Phone",
  amount: "AMOUNT",
  date: "DATE",
  bankAccountName: "Bank Account Name",
  bankNo: "Bank No.",
  createDate: "Created Date",
  status: "Status",
  approveAmount: "Approve Amount",
  confirmPayout: "Confirm Payout",
  cancel: "Cancel",
};
